<template>
  <div>
    <template v-for="page in pages" v-if="!page.settings.hidden">
      <router-link :key="page.name" :to="createPath(parentPath, page)" v-if="!(page.children instanceof Array)">
        <el-menu-item :index="page.path" :class="{'submenu-title-noDropdown':!isNest}">
          <!--<sui-icon :name="getPageIcon(page)"/>-->
          <svg-icon :icon-class="getPageIcon(page)"/>
          <span slot="title">{{ getPageName(page) }}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="page.name||page.path" :key="page.name">
        <template slot="title">
          <svg-icon :icon-class="getPageIcon(page)"/>
          <span slot="title">{{ getPageName(page) }}</span>
        </template>

        <sidebar-item v-if="page.children&&page.children.length>0"
                      :is-nest="true"
                      :pages="page.children"
                      :parent-path="createPath(parentPath, page)"
                      class="nest-menu"
        />
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { generateTitle, generatePageName } from '@/utils/i18n'

export default {
  name: 'SidebarItem',
  props: {
    pages: {
      type: Array
    },
    parentPath: {
      type: String,
      default: ''
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      kkk: 'empty'
    }
  },
  methods: {
    getPagePath (page) {
      if (page.alias) {
        return Array.isArray(page.alias) ? page.alias[0] : page.alias
      }
      return page.path
    },
    getPageIcon (page) {
      return page.settings && page.settings.icon ? page.settings.icon : 'jenkins'
    },
    getPageName (page) {
      return this.generatePageName(page)
    },
    createPath (parentPath, childPage) {
      const childPath = this.getPagePath(childPage)
      if (parentPath === '' || childPath.startsWith('/')) {
        return childPath
      }
      let path = parentPath
      if (!path.endsWith('/')) {
        path += '/'
      }
      return path + childPath
    },
    generateTitle,
    generatePageName
  }
}
</script>
<style scoped>
  .el-menu-item {
    /*padding-left: 11px;*/
    line-height: 50px;
    height: 50px;
    /*border-bottom: 1px solid #d9dadc;*/
  }
  i.icon {
    display: initial;
    font-size: 1.3em;
    margin: 0 0.8rem 0 0;
  }
  .router-link-exact-active .el-menu-item {
    color: #5e7b9b;
    background-color: #e5eaef;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue